import React from "react"

export interface IPropsOutsideLink extends React.AnchorHTMLAttributes<HTMLAnchorElement> {}

export const OutsideLink: React.FC<IPropsOutsideLink> = (props) => {
  const {target, rel, children, ...rest} = props
  return (
    <a {...rest} target={target ?? "_blank"} rel={rel ?? "noopener noreferrer"} data-sentry-component="OutsideLink" data-sentry-source-file="OutsideLink.tsx">
      {children ?? props.href}
    </a>
  )
}
